module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Waiting-0775e2e1b7b8502ba62d06be30084cfe.svg";